export default {
    color: {
        active: true,
        color: {
            r: 255,
            g: 255,
            b: 255,
            a: 1
        }
    },
    backgroundColorInteraction: {
        active: true,
        isGradient: false,
        color: {
            r: 240,
            g: 242,
            b: 248,
            a: 1
        }
    },
    backgroundColor: {
        active: true,
        color: {
            r: 112,
            g: 112,
            b: 112,
            a: 1
        }
    },
    borderColor: {
        active: false,
        color: {
            r: 112,
            g: 112,
            b: 112,
            a: 1
        }
    },
    question: {
        active: true,
        color: {
            r: 112,
            g: 112,
            b: 112,
            a: 1
        }
    },
    openField: {
        background: {
            active: true,
            color: {
                r: 255,
                g: 255,
                b: 255,
                a: 1                
            }
        },
        textColor: {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        }
    },
    backgroundType: null
}
